export default __webpack_public_path__ + "static/media/6.e4d2454d.png";